module.exports = __webpack_public_path__ + "static/media/me.44537f0d.png";